// test154
(154 && 0);
